<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">跑后分享文案</div>

    <div class="content-wrapper run-share-copy">
      <div class="left-panel">
        <div class="row title">跑后分享按钮文案</div>

        <div class="row tip">自定义文案在生效期内，APP优先展示自定义文案</div>

        <div class="row info-row">
          <span class="label">系统默认文案</span>
          <span class="value">{{ defaultCopy }}</span>
        </div>

        <div class="row info-row">
          <span class="label">自定义文案</span>
          <div class="value">
            <template v-if="customCopy.content">
              <div>{{ customCopy.content }}</div>
              <div class="effect-time">
                生效时间：{{ customCopy.startTime }}至{{ customCopy.endTime }}
              </div>
            </template>
            <span v-else>未设置内容</span>
          </div>
        </div>

        <div class="row action-row">
          <el-button type="primary" @click="clickEdit">编辑</el-button>
          <el-button @click="clickDelete">删除</el-button>
        </div>
      </div>

      <div class="right-panel">
        <div class="preview-placeholder">示意图</div>
        <img
          v-if="previewImage"
          class="preview-img"
          src="../../../../assets/images/copywriting-1.png"
        />
      </div>
    </div>

    <el-dialog
      title="自定义文案"
      :visible.sync="editDialog.visible"
      :modal-append-to-body="false"
      width="520px"
    >
      <el-form label-width="80px" label-position="left">
        <el-form-item label="文案" required>
          <el-input
            v-model="editForm.content"
            placeholder="最多12个字"
            :maxlength="12"
          ></el-input>
        </el-form-item>
        <el-form-item label="生效时间" required>
          <el-date-picker
            v-model="editForm.timeRange"
            type="datetimerange"
            placeholder="选择生效时间"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div class="dialog-footer">
          <el-button @click="editDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="clickSave">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="是否删除自定义文案?"
      :visible.sync="deleteDialog.visible"
      :modal-append-to-body="false"
      width="420px"
    >
      <div class="delete-tip">删除后，APP将展示系统默认文案</div>
      <div slot="footer">
        <div class="dialog-footer">
          <el-button @click="deleteDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="confirmDelete">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";

// 模板类型：1-跑后分享文案
const TEMPLATE_TYPE = 1;
const LIST_URL = "/adminapi/v1/textTemplate/list";
const ADD_OR_EDIT_URL = "/adminapi/v1/textTemplate/addOrEdit";
const DELETE_URL = "/adminapi/v1/textTemplate/delete";

export default {
  data() {
    return {
      loading: false,
      // 系统默认文案（接口返回，只读）
      defaultCopy: "",
      // 自定义文案（含生效时间）
      customCopy: {
        id: 0,
        content: "",
        startTime: "",
        endTime: "",
      },
      // 右侧示意图（接口待接入）
      previewImage: require("../../../../assets/images/copywriting-1.png"),
      editDialog: {
        visible: false,
      },
      editForm: {
        content: "",
        timeRange: [],
      },
      deleteDialog: {
        visible: false,
      },
    };
  },

  mounted() {
    this.queryDetail();
  },

  methods: {
    // 时间格式化（兼容时间戳 / 字符串 / ISO）
    formatTime(val) {
      if (!val && val !== 0) return "";
      const str = String(val);
      if (/^\d+$/.test(str)) {
        return dayjs(Number(str)).format("YYYY-MM-DD HH:mm:ss");
      }
      const d = dayjs(str.replace(/-/g, "/"));
      return d.isValid() ? d.format("YYYY-MM-DD HH:mm:ss") : str;
    },

    // 查询文字模板（系统默认文案 + 自定义文案）
    queryDetail() {
      this.loading = true;
      this.$http({
        method: "GET",
        url: this.$util.domain + LIST_URL,
        params: { templateType: TEMPLATE_TYPE },
      })
        .then((res) => {
          const body = res.body || {};
          if (body.error === 10000) {
            const list = body.data || [];
            const systemItem = list.find(
              (item) => Number(item.isSystemPreset) === 1
            );
            const customItem = list.find(
              (item) => Number(item.isSystemPreset) === 0
            );
            this.defaultCopy = systemItem ? systemItem.textContent || "" : "";
            this.customCopy = customItem
              ? {
                  id: customItem.id || 0,
                  content: customItem.textContent || "",
                  startTime: this.formatTime(customItem.effectiveStartTime),
                  endTime: this.formatTime(customItem.effectiveEndTime),
                }
              : { id: 0, content: "", startTime: "", endTime: "" };
          } else {
            this.$util.errorMsg(body.message || "查询失败");
          }
        })
        .catch(() => {
          this.$util.errorMsg("查询失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 点击编辑
    clickEdit() {
      this.editForm.content = this.customCopy.content || "";
      if (this.customCopy.startTime && this.customCopy.endTime) {
        this.editForm.timeRange = [
          this.toDate(this.customCopy.startTime),
          this.toDate(this.customCopy.endTime),
        ];
      } else {
        this.editForm.timeRange = [];
      }
      this.editDialog.visible = true;
    },

    // 字符串转 Date（兼容 yyyy-MM-dd HH:mm:ss / 时间戳）
    toDate(val) {
      if (!val) return "";
      const str = String(val);
      if (/^\d+$/.test(str)) {
        return new Date(Number(str));
      }
      return new Date(str.replace(/-/g, "/"));
    },

    // 保存自定义文案
    clickSave() {
      const content = (this.editForm.content || "").trim();
      if (!content) {
        this.$util.errorMsg("请输入文案");
        return;
      }
      if (content.length > 12) {
        this.$util.errorMsg("文案最多12个字");
        return;
      }
      const timeRange = this.editForm.timeRange || [];
      if (timeRange.length !== 2 || !timeRange[0] || !timeRange[1]) {
        this.$util.errorMsg("请选择生效时间");
        return;
      }
      const start = dayjs(timeRange[0]);
      const end = dayjs(timeRange[1]);
      if (!start.isBefore(end)) {
        this.$util.errorMsg("开始时间必须早于结束时间");
        return;
      }
      if (!end.isAfter(dayjs())) {
        this.$util.errorMsg("结束时间必须晚于当前时间");
        return;
      }

      const param = {
        id: this.customCopy.id || 0,
        templateType: TEMPLATE_TYPE,
        textContent: content,
        effectiveStartTime: start.format("YYYY-MM-DD HH:mm:ss"),
        effectiveEndTime: end.format("YYYY-MM-DD HH:mm:ss"),
      };

      this.$http({
        method: "POST",
        url: this.$util.domain + ADD_OR_EDIT_URL,
        dataType: "json",
        body: JSON.stringify(param),
      })
        .then((res) => {
          const body = res.body || {};
          if (body.error === 10000) {
            this.$util.successMsg("保存成功");
            this.editDialog.visible = false;
            this.queryDetail();
          } else {
            this.$util.errorMsg(body.message || "保存失败");
          }
        })
        .catch(() => {
          this.$util.errorMsg("保存失败");
        });
    },

    // 点击删除
    clickDelete() {
      if (!this.customCopy.id) {
        this.$util.errorMsg("暂无可删除的自定义文案");
        return;
      }
      this.deleteDialog.visible = true;
    },

    // 确认删除
    confirmDelete() {
      this.$http({
        method: "GET",
        url: this.$util.domain + DELETE_URL,
        params: { id: this.customCopy.id },
      })
        .then((res) => {
          const body = res.body || {};
          if (body.error === 10000) {
            this.$util.successMsg("删除成功");
            this.deleteDialog.visible = false;
            this.queryDetail();
          } else {
            this.$util.errorMsg(body.message || "删除失败");
          }
        })
        .catch(() => {
          this.$util.errorMsg("删除失败");
        });
    },
  },
};
</script>

<style scoped>
.run-share-copy {
  display: flex;
  align-items: flex-start;
}

.left-panel {
  flex: 2;
  /* min-width: 0; */
  padding-right: 24px;
}

.left-panel .row {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.6;
}

.left-panel .title {
  font-size: 16px;
  font-weight: bold;
}

.left-panel .tip {
  color: #909399;
}

.info-row {
  display: flex;
  align-items: flex-start;
}

.info-row .label {
  flex: none;
  width: 100px;
  color: #606266;
}

.info-row .value {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.effect-time {
  margin-top: 4px;
  color: #909399;
}

.action-row {
  margin-top: 20px;
}

.right-panel {
  flex: 3;
}

.preview-img {
  display: block;
  width: 350px;
  height: auto;
}

.preview-placeholder {
  color: #c0c4cc;
  font-size: 14px;
}

.delete-tip {
  font-size: 14px;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// RunShareCopy.vue?f77fc180